import axios from 'axios';
import config from './config';

// withCredentials: true sends the HttpOnly __ttauth cookie on every request.
// The cookie is set by the tt-auth proxy on the same origin as the API.
const api = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
});

// Request interceptor (no token injection needed with cookie auth)
api.interceptors.request.use(
  (reqConfig) => reqConfig,
  (error) => {
    console.error('[API] Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor — handle non-auth errors.
// NOTE: 401 handling (redirect to login) is intentionally left to each
// component (ProtectedRoute) so the public landing page "/" can render
// without being hijacked by an auto-redirect when no cookie is present.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error(`[API] Error: ${error.response.status} ${error.config.url}`, error.response.data);
    } else {
      console.error('[API] Network error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;